module.exports = __webpack_public_path__ + "static/media/rojo.ed31c798.png";